'use strict';
(function($){
    /*
     * Vetology.FloatingTranslator widget
     *
     * @description This ios the main Vetology widget to load the tools needed in the page
     *				By the time this plugin runs, all othrs should have already been loaded, so this should be the last script to be loaded;
     *
     * @options					See description for each option
     *
     * @method	See description above each method
     */
    $.widget(
        'Vetology.floatingTranslator',
        {
            options: {
                icon: ""
            },

            /*
             * Vetology.Vetology._create
             *
             * @description Vetology.FloatingTranslator constructor
             *
             * @return NULL
             *
             */

            "_create": function(){
                var o = this;

                var traslator_element_definition = '<div class="floating-language navbar-fixed-right" tabindex="0" data-trigger="hover"  data-html="true" data-placement="left" data-toggle="popover" data-container="body" data-content="Language">';
                traslator_element_definition+= '<div class="icon-wrapper"><i class="' + o.options.icon + '"></i></div>';
                traslator_element_definition+= '<div class="language-wrapper"><div class="row"><div class="col"><div id="google_translate_element"></div></div></div></div></div>';
                o.traslator_element = $(traslator_element_definition);
                o.traslator_element.popover();
                $(o.element).append(o.traslator_element);

              o._loadEvents();
            },
            /*
             * Vetology.Vetology._init
             *
             * @description	Initializes the Vetology Platform
             *
             * @return NULL
             *
             */
            "_init": function(){
                var o = this;
            },
            "_loadEvents": function(){
                var o = this;

                $("body").on("click", ".floating-language", function(e){
                    $(".floating-language").popover("destroy");
                    if($(e.target).hasClass('goog-te-combo')){
                        return;
                    }

                    if($(".language-wrapper").css('display') == "none"){
                        $(".language-wrapper").animate(
                            {
                                width: 'toggle'
                            }
                        );
                    }
                });

                $("body").on("focusout", ".floating-language", function(e){
                    if($(e.target).hasClass('goog-te-combo')){
                        return;
                    }
                    //Checking if the floating-language has lost the focus
                    setTimeout(function(){
                        var focus = $(document.activeElement);
                        if(!(focus.is(".floating-language") || $('.floating-language').has(focus).length)){
                            $(".language-wrapper").animate(
                                {
                                    width: 'toggle'
                                },
                                function(){
                                    $(".floating-language").popover();
                                }
                            );
                        }
                    });
                });

                $("body").on("change", ".goog-te-combo", function(e){
                    $(".language-wrapper").animate(
                        {
                            width: 'toggle'
                        },
                        function(){
                            $(".floating-language").popover();
                        });
                });
            }
        }
    );
})(jQuery);